/* ToxVeto — Conversion Lander shared behaviour.
   Scroll reveal + FAQ accordion + mini-proof carousel.
   Everything re-initialises on shopify:section:load so the theme editor
   behaves the same as the storefront. */
(function () {
  'use strict';

  /* ---- Scroll reveal ---------------------------------------------------- */
  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.tvc-reveal:not(.tvc-in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('tvc-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('tvc-in');
          io.unobserve(e.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  /* ---- FAQ accordion ---------------------------------------------------- */
  function accordions(root) {
    var groups = (root || document).querySelectorAll('[data-tvc-accordion]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.tvcBound === '1') return;
      group.dataset.tvcBound = '1';

      var single = group.getAttribute('data-tvc-accordion') === 'single';

      group.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-tvc-q]');
        if (!btn || !group.contains(btn)) return;

        var item = btn.parentNode;
        var panel = item.querySelector('[data-tvc-a]');
        if (!panel) return;

        var open = btn.getAttribute('aria-expanded') === 'true';

        if (single && !open) {
          Array.prototype.forEach.call(group.querySelectorAll('[data-tvc-q][aria-expanded="true"]'), function (other) {
            other.setAttribute('aria-expanded', 'false');
            var op = other.parentNode.querySelector('[data-tvc-a]');
            if (op) op.style.maxHeight = '';
            other.parentNode.classList.remove('is-open');
          });
        }

        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        item.classList.toggle('is-open', !open);
        panel.style.maxHeight = open ? '' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---- Mini-proof carousel --------------------------------------------- */
  function carousels(root) {
    var els = (root || document).querySelectorAll('[data-tvc-carousel]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.tvcBound === '1') return;
      el.dataset.tvcBound = '1';

      var track = el.querySelector('[data-tvc-track]');
      var prev = el.querySelector('[data-tvc-prev]');
      var next = el.querySelector('[data-tvc-next]');
      if (!track) return;

      function step() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Autoplay, paused on hover/focus, skipped for reduced-motion users.
      var speed = parseInt(el.getAttribute('data-tvc-autoplay'), 10) || 0;
      if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var timer = null;
        var play = function () {
          timer = setInterval(function () {
            var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
            else track.scrollBy({ left: step(), behavior: 'smooth' });
          }, speed);
        };
        var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
        el.addEventListener('mouseenter', stop);
        el.addEventListener('mouseleave', play);
        el.addEventListener('focusin', stop);
        el.addEventListener('focusout', play);
        play();
      }
    });
  }

  function boot(root) {
    reveal(root);
    accordions(root);
    carousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
